import { useState } from 'react';
import { hooks as commonHooks } from '@sitebuilder/common';
import FilterDropdown from './FilterDropdown';
import SearchBox from './SearchBox';

interface PropsShape {
    config: {
        id: string;
        label: string;
        values: {
            label: string;
            value: string;
        }[];
    }[];
    filterState: Record<string, string>;
    setFilters: (selection: Record<string, string>) => void;
    searchTerm: string;
    searchLabel: string;
    searchTitle: string;
    setSearchTerm: (searchTerm: string) => void;
    dataContext: any;
    isInformationFolderVisible: boolean;
}

export default function MobileFilters(props: PropsShape) {
    const {
        setSearchTerm,
        filterState,
        searchTerm,
        searchLabel,
        searchTitle,
        setFilters,
        dataContext,
        isInformationFolderVisible,
    } = props;
    const [showFilters, setShowFilters] = useState(false);

    const handleDropdownSelectionChange = (propertyId: string, selectedValue: string) => {
        setFilters({
            ...filterState,
            [propertyId]: selectedValue,
        });
    };

    const handleSearchTermChange = (value: string) => {
        setSearchTerm(`${value}`.trim());
    };

    const handleShowFilters = () => {
        setShowFilters(!showFilters);
    };

    const i18n = commonHooks.useLocalization();

    return (
        <form
            className={`filters sticky-header ${
                isInformationFolderVisible ? 'information-visible' : ''
            }`}
            onSubmit={(e) => e.preventDefault()}
        >
            <div className="row">
                <SearchBox
                    searchLabel={searchLabel}
                    searchTitle={searchTitle}
                    value={searchTerm}
                    onChange={handleSearchTermChange}
                    dataContext={dataContext}
                />
                <button onClick={handleShowFilters}>
                    {showFilters ? i18n.t('hide_filter') : i18n.t('show_filter')}
                </button>
                {showFilters && (
                    <div
                        className={`mobile filter-dropdowns-container ${showFilters ? 'open' : ''}`}
                    >
                        {props.config.map((c) => {
                            const opts = c.values;
                            opts.forEach((o: any) => {
                                o.selected = filterState && filterState[c.id] === o.value;
                            });

                            return (
                                <FilterDropdown
                                    key={c.id}
                                    id={c.id}
                                    label={c.label || c.id}
                                    options={
                                        opts as {
                                            label: string;
                                            value: string;
                                            selected: boolean;
                                        }[]
                                    }
                                    onChange={(v) => handleDropdownSelectionChange(c.id, v)}
                                    dataContext={dataContext}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </form>
    );
}
